// import the container components
import AddToPlaylist from './components/add-to-playlist/AddToPlaylist';
import Bookmark from './components/bookmark/Bookmark';
import BookmarkListing from './components/bookmark-listing/BookmarkListing';
import Comment from './components/comment/Comment';
import FeaturedArticles from './components/featured-articles/FeaturedArticles';
import FeaturedClasses from './components/featured-classes/FeaturedClasses';
import HelloWorld from './components/hello-world/HelloWorld';
import Playlist from './components/playlist/Playlist';
import PlaylistListing from './components/playlist-listing/PlaylistListing';
import Recommendation from './components/recommendation/Recommendation';
import RedirectPage from './components/redirect-page/RedirectPage';
import TheaterTalks from './components/theater-talks/TheaterTalks';
import UpcomingEvents from './components/upcoming-events/UpcomingEvents';
import UserMenu from './components/user-menu/UserMenu';
import BannerTiles from '../components/presentational/BannerTiles';
import ContainerWithSidebar from '../components/presentational/ContainerWithSidebar/ContainerWithSidebar';
import HeadingWithLink from '../components/presentational/HeadingWithLink/HeadingWithLink';
import Hero from '../components/presentational/Hero/Hero';
import HeroBanner from '../components/presentational/HeroBanner/HeroBanner';
import ImageCardGrid from '../components/presentational/ImageCardGrid';
import IndustryCards from '../components/presentational/IndustryCards';
import InfoBox from '../components/presentational/InfoBox';
import PlaylistsContainer from '../components/presentational/Playlists/PlaylistsContainer';
import YellowCardGrid from '../components/presentational/YellowCardGrid';

// export the library of components available
export default {
  AddToPlaylist,
  Bookmark,
  BookmarkListing,
  TheaterTalks,
  UpcomingEvents,
  FeaturedArticles,
  FeaturedClasses,
  HelloWorld,
  UserMenu,
  Recommendation,
  Comment,
  RedirectPage,
  Playlist,
  PlaylistListing,
  PlaylistsContainer,
  BannerTiles,
  ContainerWithSidebar,
  HeadingWithLink,
  Hero,
  HeroBanner,
  ImageCardGrid,
  YellowCardGrid,
  InfoBox,
  IndustryCards,
};
